<ng-container *transloco="let t; read: 'exercise'">
  <div class="main-content" *ngIf="slot !== null">
    <app-content-header
      [title]="slot.exercisename + ': ' + slot.name"
      [group]="group"
      [candidate]="candidate"
      [slot]="slot"
    >
    </app-content-header>

    <div class="layout-content">
      <app-close-button></app-close-button>

      <div class="acr-card-body">

        <ng-container *ngIf="isEntitled() === true && element !== null">
          <app-tab-selector [tabs]="tabs" [active]="activeTab" [docMode]="true" (activeChange)="onTabChanged($event)"></app-tab-selector>
          <app-content-container [element]="element"></app-content-container>
        </ng-container>

        <div *ngIf="elements?.length > 0 && isEntitled() !== true" class="not-entitled">
          <p class="topline">{{ slot.exercisename }}: {{ slot.name }}</p>
          <fa-icon class="p-pb-4 icon" [icon]="faTrafficLightStop"></fa-icon><br>
          {{ t('messages.no_rights') }}
        </div>

        <div class="no-elements" *ngIf="elements?.length === 0">
          <p class="topline">{{ slot.exercisename }}: {{ slot.name }}</p>
          <p>
            <fa-icon class="p-pb-4 icon" [icon]="faFolderOpen"></fa-icon><br>
            {{ t('messages.no_documents') }}
          </p>
        </div>

      </div>
    </div>
  </div>

</ng-container>
